module.exports = __webpack_public_path__ + "img/opdrachten-ico.31fe439a.svg";